import { connect } from 'react-redux';
import FullUploadProductCustomisation from './FullUploadProductCustomisationComponent';

const mapStateToProps = (state) => ({
  config: state.config,
  parentLocation: state.newProduct.parentLocation,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FullUploadProductCustomisation);
